<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      <div class="datatable-outer-container margintop-30 margin-left-20">
              <tl-select
                label="Select Component"
                labelText="name"
                :name="'components'"
                :options="nonCtcComponentsList"
                :disabled="false"
                v-validate="{required: false}"
                :classname="errors.has('components')"
                errormsg="Component is required"
                @change="(val) => assignedComponentsObj = val"
              />
            <div class="row-container margintop-16">
              <div>
                <div class="input-label">From Date</div>
                <date-picker
                  class="ht-35 margin-top-5"
                  :name="'applicableFrom'"
                  @datevalue="(val)=>applicableFrom=val"
                  :value="applicableFrom"
                  v-model="applicableFrom"
                  :formatDate="'dd-MM-yyyy'"
                  :disabled="false"
                  @change="dateChanged(index)"
                  v-validate="{required: true}"
                  :classname="errors.has('applicableFrom')"
                  errormsg="Applicable from is required"
                />
              </div>
              <div class="ml-5">
                <div class="input-label">To Date</div>
                <date-picker
                  class="ht-35 margin-top-5"
                  :name="'applicableTill'"
                  @datevalue="(val)=>applicableTill=val"
                  :value="applicableTill"
                  v-model="applicableTill"
                  :formatDate="'dd-MM-yyyy'"
                  :disabled="false"
                  :dates-disabled="{to: new Date(applicableFrom)}"
                  v-validate="{required: true}"
                  :classname="errors.has('applicableTill')"
                  errormsg="Applicable till is required"
                />
              </div>
            </div>
            <txt
              class="margintop-16"
              label="Amount"
              :name="'amount'"
              :autofocus="false"
              v-model="amount"
              :disabled="false"
              v-validate="{required: true}"
              :classname="errors.has('amount')"
              errormsg="Amount is required"
            />
      </div>
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message>

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="save" />
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "assignNonCTCcomponentsToEmployees",
  props: {
    empId: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      showUnAssignModal: false,

      salaryComponents: [],
      componentsList: [],

      assignedComponentsList: [],

      modalObj: {
        effectiveDate: "",
        name: "Basic",
        applicableFrom: "",
        applicableTill: ""
      },

      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },
      selectedUnassignRecord: {},
      amount: 0,
      applicableFrom: "",
      applicableTill: "",
      nonCtcComponentsList: [],
      editMode: false,
      assignedComponentsObj: {},
      formData: {
        "employee_id": "",
        "legal_entity_id": "",
        "salary_component_id": "",
        "salary_component_code": "",
        "value": "",
        "from": "",
        "to": "",
        "assigned_date": "",
        "unassigned_date": ""
      }
    };
  },
  computed: {
    ...mapState({
      orgData: state => state.onboard.organization.state.data[0],
      getRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.record,
      getEditMode: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.editMode,
      getSelectedRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.data[state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.selectedEmployeeIndex]
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      // getRecord: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/record"
    }),

    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },

  mounted() {
    this.getNonCTCComponents();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.getNonCTCComponents();

    this.getLegalEntitySalaryComponents();

    this.employeeObject = this.getRecord;//this.getSelectedRecord; //this.getRecord;
    this.assignedComponentsList = [];
    // this.empId=this.editRecord
    this.empId=this.getRecord
    this.editMode=this.getEditMode

    if (this.employeeObject.EmployeeNonCTCComponent) {
      if (this.employeeObject.EmployeeNonCTCComponent.salary_component) {
        if (
          this.employeeObject.EmployeeNonCTCComponent.salary_component.length
        ) {
          this.employeeObject.EmployeeNonCTCComponent.salary_component.forEach(
            (element, index) => {
              let obj = {
                id: element.salary_component_id,
                applicableFrom: element.from,
                applicableTill: element.to,
                amount: element.value,
                unassign_date: element.unassign_date
                  ? element.unassign_date
                  : null,
                // advanced_setting: element.advanced_setting
                //   ? element.advanced_setting
                //   : null,
                assigned_date: new Date(),
                showDropDown: false,
                isEditable: false
              };
              this.assignedComponentsList.push(obj);
            }
          );
          this.assignedComponentsList = [...this.assignedComponentsList];
        }
      }
    }

    if (this.assignedComponentsList.length == 0) {
      this.assignedComponentsList.push({
        id: null,
        applicableFrom: "",
        applicableTill: "",
        amount: null,
        componentObj: null,
        unassign_date: null,
        assigned_date: new Date(),
        // advanced_setting: null,
        showDropDown: false,
        isEditable: true
      });
    }
  },

  methods: {
    ...mapActions({
      fetchNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchNonCtcComponents",
      act_create: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/create",
      act_update: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/update",
      updateNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/updateNonCtcComponents",
      fetchLegalEntitySalaryComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchLegalEntitySalaryComponents",
      act_changeEmployeeNonCtcComponentEditMode:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/changeEmployeeNonCtcComponentEditMode",
      act_fetch_nonctc_comp: "onboard/employees/fetchAllNonCTCcomponents"
    }),

    dateChanged(index) {
      //console.log("dateChanged:", index);
    },

    edit(item, index) {
      item.isEditable = !item.isEditable;
      item.showDropDown = !item.showDropDown;
    },

     async advanceSettings(item, index) {
      //console.log("advanceSettings:", item);

      if (index > -1) {
        try {
          await this.act_changeEmployeeNonCtcComponentEditMode({
            record: item,
            index: index
          });
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/advanceSettings`,
            query: { componentIndex: index }
          });
        } catch (err) {
          this.toast = true;
          this.errmsg = err.message;
        }
      }
    },

    close() {
      this.showSuccessMsg = false;
      this.$emit('back');
    },

    getEmpEncryptedString() {
      return this.$route.query.employee;
    },

    /* server call to get non ctc components for current Legal Entity*/
    async getNonCTCComponents() {
      try {
        let res = await this.act_fetch_nonctc_comp(this.le_id);
        if (res.data.status) {
          this.nonCtcComponentsList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    setSalaryComponetsData(element, index) {
      this.componentsList.forEach((item, j) => {
        if (element.salary_component_id == item.id) {
          this.assignedComponentsList[index].componentObj = item;
        }
      });
      this.componentsList = [...this.componentsList];
    },

    addNonCTCcomponent() {
      let obj = {
        id: null,
        applicableFrom: "",
        applicableTill: "",
        amount: null,
        unassign_date: null,
        assigned_date: new Date(),
        // advanced_setting: null,
        componentObj: null,
        isEditable: true
      };

      this.assignedComponentsList.push(obj);
    },

    async create() {
      try {
        //console.log("this.empId : ", this.empId);
        //console.log("this.formData : ", this.formData);
        this.formData.employee_id = this.empId.id;
        this.formData.legal_entity_id = this.assignedComponentsObj.le_id;
        this.formData.salary_component_id = this.assignedComponentsObj.id;
        this.formData.salary_component_code = this.assignedComponentsObj.code;
        this.formData.from = this.applicableFrom;
        this.formData.to = this.applicableTill;
        this.formData.value = this.amount;
        //console.log("this.formData : ", this.formData);
        if (this.editMode) {
          this.$root._data.isSaving = true;
          // this.formData.name = this.formData.name.toString().trim();
          // this.formData.id = this.record.id;
          let res = await this.act_update({...this.formData});
          if (res.data.status) {
            this.showSuccessMsg = true;
            setTimeout(() => {
              this.$root._data.isSaving = false;
            }, 500);
          }
        } else {
          this.$root._data.isSaving = true;
          let res = await this.act_create({...this.formData});
          if (res.data.status) {
            this.showSuccessMsg = true;
            setTimeout(() => {
              this.$root._data.isSaving = false;
            }, 500);
          }
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getLegalEntitySalaryComponents() {
      try {
        let res = await this.fetchLegalEntitySalaryComponents(this.le_id);
        //console.log("getLegalEntitySalaryComponents:", res);

        if (res.status == 200 || res.status == 201) {
          this.componentsList = res.data.payload.data;

          if (this.employeeObject.EmployeeNonCTCComponent) {
            if (this.employeeObject.EmployeeNonCTCComponent.salary_component) {
              if (
                this.employeeObject.EmployeeNonCTCComponent.salary_component
                  .length
              ) {
                this.employeeObject.EmployeeNonCTCComponent.salary_component.forEach(
                  (element, index) => {
                    this.setSalaryComponetsData(element, index);
                  }
                );

                // //console.log(
                //   "assignedComponentsList:",
                //   this.assignedComponentsList
                // );
              }
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    componentChanged(event, index) {
      //console.log("componentChanged:", event);

      if (index > -1) {
        this.assignedComponentsList[index].componentObj = event;
        //this.assignedComponentsList[index].id = event.id;
      }
    },

    deleteRecord(item, index) {
      this.assignedComponentsList.splice(index, 1);
    },

    cancel() {
      // this.refresh();
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
      // });
      this.$emit('back');
    },

    async save() {
      this.create();
      // this.$validator.validateAll().then(result => {
      //   if (result) {
      //     this.performAction();
      //   }
      // });
    },

    async performAction() {
      let addedComponentsArr = this.assignedComponentsList;
      let finalArr = [];

      for (let i = 0; i < addedComponentsArr.length; i++) {
        let salaryComponentObj = addedComponentsArr[i];

        if (!salaryComponentObj.amount || salaryComponentObj.amount == "0") {
          this.toast = true;
          this.errmsg = "Amount cannot be zero";
          return;
        }

        this.toast = false;
        this.errmsg = "";

        let obj = {
          salary_component_id: salaryComponentObj.componentObj
            ? salaryComponentObj.componentObj.id
            : null,
          from: salaryComponentObj.applicableFrom,
          to: salaryComponentObj.applicableTill,
          amount: salaryComponentObj.amount,
          name: salaryComponentObj.componentObj
            ? salaryComponentObj.componentObj.name
            : null,
          unassign_date: salaryComponentObj.unassign_date
            ? salaryComponentObj.unassign_date
            : null,
          // advanced_setting: salaryComponentObj.advanced_setting
          //   ? salaryComponentObj.advanced_setting
          //   : null,
          assigned_date: salaryComponentObj.assigned_date
            ? salaryComponentObj.assigned_date
            : null,
          status: this.getStatus(salaryComponentObj)
        };
        finalArr.push(obj);
      }

      try {
        let obj = {
          data: {
            employee_id: this.employeeObject.id,
            //financial_year:"2019-2020",
            legal_entity_id: this.le_id,
            salary_component: finalArr
          }
        };

        //console.log("performAction:", obj);

        let res = await this.updateNonCtcComponents(obj);
        //console.log("updateNonCtcComponents:", res);

        if (res.status == 200 || res.status == 201) {
          this.cancel();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        //console.log("error:", err);
      }
    },

    getStatus(salaryComponentObj){

      let currentDate = new Date();
      let from = new Date(salaryComponentObj.applicableFrom) ;
      let to = new Date(salaryComponentObj.applicableTill) ;


      if (salaryComponentObj.unassign_date){
        return "Unassigned";
      }else if (currentDate < from){
        return "Scheduled";
      }else if (currentDate > from && currentDate < to){
        return "Active";
      }else{
        return "Completed";
      }

    },

    unAssign(item, index) {
      this.showUnAssignModal = true;
      item.showDropDown = !item.showDropDown;
      this.selectedUnassignRecord = item;
      this.modalObj.name = item.componentObj ? item.componentObj.name : "";
      this.modalObj.effectiveDate = item.unassign_date
        ? item.unassign_date
        : null;

      this.modalObj.applicableFrom = item.applicableFrom
        ? item.applicableFrom
        : "";
      this.modalObj.applicableTill = item.applicableTill
        ? item.applicableTill
        : "";
    },

    refresh() {
      (this.componentsList = []),
        (this.assignedComponentsList = []),
        (this.employeeObject = {
          id: null,
          name: null,
          code: null,
          email_id: null
        });
    },

    cancelModal() {
      this.showUnAssignModal = false;
    },

    saveModalData() {
      this.selectedUnassignRecord.unassign_date = this.modalObj.effectiveDate;
      this.showUnAssignModal = false;

      this.performAction();
    }
  }
};
</script>

<style lang="scss" scoped>
.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -140px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #979797;
        }
      }
    }
  }
}
.flex-box {
  display: flex;
  .row-container {
    margin-right: 20px;
  }
  margin-bottom: 60px;
}

.text-green {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  color: #34c0be;
}

.margin-left-20 {
  margin: 20px 36px 0px 0px;
}

.card {
  display: flex;
  width: 25%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 100px;
    height: 100px;
    padding: 10px 0 0 10px;
  }
}

.emp-details {
  padding: 20px 0 0 10px;
  color: #535353;
}

.Rectangle {
  width: 316px;
  height: 102px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.close-card {
  cursor: pointer;
  color: #6e6e6e;
  width: 12px;
  height: 12px;
  padding: 2px 0 0 160px;
}

.bottom-75 {
  margin-bottom: 75px;
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}

.content-new {
  margin: 30px 77px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0;
}

.business {
  width: 100%;
  height: 100%;
}

.business .top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.line {
  margin-left: 4px;
  margin-bottom: 5px;
  margin-top: 18px;
  margin-right: 30px;
  border-bottom: 1px solid #34c0be;
}

.contbtn {
  margin-top: 30px;
  float: right;
  margin-right: 30px;
  width: 154px;
  height: 45px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
  color: #ffffff;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.custom-width {
  width: 300px;
}

.datatable-outer-container {
  width: auto;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}

.custom-input {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: 35px;
  -webkit-transition: ease-in-out, width 0.35s ease-in-out;
  transition: ease-in-out, width 0.35s ease-in-out;
  :focus {
    border: 1px solid #34c0be;
  }
}

.advanced-Setting {
  width: auto;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #5d409f;
  text-decoration: underline;
  cursor: pointer;
}

.un-assign-text {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  color: #646464;
  text-align: center;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-10 {
  margin: 10px;
}
</style>
